import { r } from './useApi';
import { keeper } from './utils';
import { normalizeBySchema } from './useDataModels';

export const listPlaceholderRefs = async (filter = {}) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/placeholderRef`,
        sessionToken: keeper('sessionToken'),
        data: filter,
    });
    return res;
};

export const getPlaceholderRef = async (id) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/placeholderRef/${id}`,
        sessionToken: keeper('sessionToken'),
    });
    return res;
};

export const savePlaceholderRef = async (placeholderRefId, data) => {
    let method = 'put',
        defaultTypeName = 'PlaceholderDefinitionRefRequest',
        searchEndpoint = '/v2/placeholderRef/{placeholderRefId}',
        endpoint = `${keeper('apiUrl')}/v2/placeholderRef/${placeholderRefId}`;

    if (placeholderRefId === '0') {
        method = 'post';
        // THIS WILL CHANGE defaultTypeName = 'PlaceholderDefinitionRefRequest';
        searchEndpoint = '/v2/placeholderRef';
        endpoint = `${keeper('apiUrl')}/v2/placeholderRef`;
    }
    const dataModel = await normalizeBySchema(searchEndpoint, method, data);
    dataModel.typeName =
        !dataModel.typeName || dataModel.typeName.length === 0
            ? defaultTypeName
            : dataModel.typeName;
    const res = await r({
        endpoint: endpoint,
        sessionToken: keeper('sessionToken'),
        method: method,
        data: dataModel,
    });
    return res;
};

export const removePlaceholderRef = async (placeholderDefRefId) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/placeholderRef/${placeholderDefRefId}`,
        sessionToken: keeper('sessionToken'),
        method: 'delete',
    });
    return res;
};

export const usePlaceholderRefs = async () => {
    return {
        listPlaceholderRefs: listPlaceholderRefs,
        getPlaceholderRef: getPlaceholderRef,
        savePlaceholderRef: savePlaceholderRef,
        removePlaceholderRef: removePlaceholderRef,
    };
};

export default usePlaceholderRefs;
